import {StringPatternSchema} from 'favorlogic-utils';

import {validationRegularExpressions} from 'utils/DairyValidator';

export const VeterinaryIdSchema = StringPatternSchema<VeterinaryId>(validationRegularExpressions.veterinaryId);

export type VeterinaryId = string;
